module.exports = {"testing":"HOLA"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/es.json
// module id = 796
// module chunks = 2